import { render, staticRenderFns } from "./docthIndex.vue?vue&type=template&id=297e8336&"
import script from "./docthIndex.vue?vue&type=script&lang=js&"
export * from "./docthIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports